import { render, staticRenderFns } from "./BookingListPage.vue?vue&type=template&id=30858684&scoped=true"
import script from "./BookingListPage.vue?vue&type=script&lang=js"
export * from "./BookingListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30858684",
  null
  
)

export default component.exports